import request from './request'

//获取菜单列表
export function getMenuList(params) {
    return request({
        url: '/site/api/yymenu/list',
        method: 'get',
        params: params
    })
}

//获取菜单对象
export function getMenuInfo(id) {
    return request({
        url: '/site/api/yymenu/'+id,
        method: 'get'
    })
}

//logo
export function getLogo() {
    return request({
        url: '/site/api/config/logo',
        method: 'get'
    })
}
//contact
export function getContact() {
    return request({
        url: '/site/api/config/contact',
        method: 'get'
    })
}
//qrcode
export function getQrcode() {
    return request({
        url: '/site/api/config/qrcode',
        method: 'get'
    })
}

//获取内容信息列表
export function getContentList(params) {
    return request({
        url: '/site/api/content/list',
        method: 'get',
        params: params
    })
}
//获取内容信息列表
export function getContentInfo(id) {
    return request({
        url: '/site/api/content/'+id,
        method: 'get'
    })
}